import { render } from "./DemandNotice.vue?vue&type=template&id=05134731&scoped=true"
import script from "./DemandNotice.vue?vue&type=script&lang=js"
export * from "./DemandNotice.vue?vue&type=script&lang=js"

import "./DemandNotice.vue?vue&type=style&index=0&id=05134731&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05134731"]])

export default __exports__